module.exports = __webpack_public_path__ + "img/symbol_5.43799e91.png";